module.exports = __webpack_public_path__ + "static/media/book3.eb158ad3.png";